import React, { Component } from 'react';
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
} from '@knockrentals/knock-react';
import { Formik } from 'formik';

import '../../_attributeInfo.scss';

class AddAttributeTypeModal extends Component {
  state = {
    attributeType: '',
  };

  render() {
    return (
      <Modal className="attribute-modal">
        <Formik
          initialValues={{ attributeType: '' }}
          validate={this.validate}
          onSubmit={this.onConfirm.bind(this)}
        >
          {(props) => (
            <form onSubmit={props.handleSubmit} autoComplete="off">
              <ModalHeader>
                <h2>Add New Attribute Type</h2>
              </ModalHeader>
              <ModalContent>
                <div className="knock-react-flex">
                  <div className="field-label">Attribute Type</div>
                  <div className="field-input">
                    <input
                      name="attributeType"
                      type="text"
                      onChange={props.handleChange}
                      value={props.values.attributeType}
                      className="knock-react-input"
                      placeholder="e.g. Region, Type, Ownership, Stage, etc..."
                    />
                    {!!props.errors.attributeType && (
                      <span className="knock-react-form-hint knock-react-form-hint-error">
                        {props.errors.attributeType}
                      </span>
                    )}
                  </div>
                </div>
              </ModalContent>
              <ModalFooter>
                <button
                  className="btn-md btn-primary"
                  onClick={this.onCancel.bind(this)}
                  type="button"
                >
                  <i className="fa fa-lg fa-times-circle" /> Cancel
                </button>
                <button className="btn-md btn-success" type="submit">
                  <i className="fa fa-lg fa-check-circle" /> Add Attribute Type
                </button>
              </ModalFooter>
            </form>
          )}
        </Formik>
      </Modal>
    );
  }

  onConfirm(values) {
    this.props.createAttributeType(values.attributeType.trim());
  }

  onCancel() {
    this.props.toggleModal(false);
  }

  validate(values) {
    const errors = {};

    if (!values.attributeType.trim()) {
      errors.attributeType = 'Required';
    }

    return errors;
  }
}

export default AddAttributeTypeModal;
